<template>
    <div>
        <Navbar />
        <Header :category="'organizers'" :bannerTitle="bannerTitle" :breadCrumb="borrowSpaceCrumb" />
        <AccommodationBody />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/KECC/Common/NavbarStyle'
    import Header from 'components/DefaultHome/KECC/Common/Header'
    import AccommodationBody from './AccommodationBody'
    import FooterTop from 'components/DefaultHome/KECC/Common/FooterTop?v=1.0'
    import FooterBottom from 'components/DefaultHome/KECC/Common/BacktopButton'
    export default {
        name: 'FacilityMain',
        metaInfo() {
            return {
                title: this.$t("navbar.menu_1_5"),
            }
        },
        components: {
            Navbar,
            Header,
            AccommodationBody,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: "FACUKUTUES<br>SERVICE",
                borrowSpaceCrumb: [{
                    name: this.$t('navbar.menu_1_5')
                }]
            }
        }
    }
</script>